import React, { Component } from 'react';
//import 'react-select/dist/react-select.css';


var Block = React.createClass({
  click: function(){
    this.props.addSpecialty(this.props.id);
  },
  render: function(){
    if(this.props.active){
      return(
        <div  onClick={this.click} className="block">{this.props.children}</div>
      );
    }else{
      return null;
    }
    
  }
});

export default Block;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/AdminPanel/components/CreatePanelTest/components/SelectSpecialties/components/Block/index.jsx
 **/